import { createAsyncAction } from 'typesafe-actions'
import { ChatState } from '../../types'
import { Failure, Request, Success } from './types'

export const finalCloseChatAction = createAsyncAction(
  '@chat/FINAL_CLOSE_CHAT_REQUEST',
  '@chat/FINAL_CLOSE_CHAT_SUCCESS',
  '@chat/FINAL_CLOSE_CHAT_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState): ChatState => ({
  ...state,
  isLoadingFinalCloseChat: true,
  isSuccessOnFinalCloseChat: false,
  isErrorOnFinalCloseChat: false
})

const success = (state: ChatState): ChatState => {
  return {
    ...state,
    isSuccessOnFinalCloseChat: true,
    isLoadingFinalCloseChat: false
  }
}
const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingFinalCloseChat: false,
  isErrorOnFinalCloseChat: true
})

export const finalCloseChatHandle = { asyncAction: finalCloseChatAction, request, success, failure }
